export function FormGoogleAnalytics(id, completionId, previewMode)
{
    var obj = {
        getGAData: getGAData
    };
    return obj;

    //-------------------------------------------------------------------------------------------------
    // Get all of the properties from the all of the input type=hidden element under the widget
    //-------------------------------------------------------------------------------------------------    
    function getGAData() {
        const classList = [
            "nodeguid",
            "pagename",
            "pageurl",
            "gaclientid",
            "gauserid",
            "gatrackid",
            "galastwebcampaign",
            "galastwebmedium",
            "galastwebsource",
            "gawebcampaignstack",
            "gawebleadid",
            "gadevicetype",
            "gaclid",
            "msclkid",
            "web_event_id",
            "fbc",
            "fbp",
            "formpage",
            "twclid",
            "li_fat_id",
            "gautmid",
            "gawebtactic"
        ];

        // Read values from the hidden fields on the page with a class= matching one of the values above.
        var inputs = document.querySelectorAll('input[type="hidden"]');
        var gaValues = {};
        for (var i = 0; i < inputs.length; i++) {
          var input = inputs[i];
          if (classList.indexOf(input.getAttribute('class')) !== -1) {
            var cls = input.getAttribute('class');
            var value = input.getAttribute('value');
            gaValues[cls] = value;
          }
        }
        return gaValues;
    }
}

export default FormGoogleAnalytics;
